import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AuthService, Cart, CartExportService, Customer, ExportCartSelectionDataType, GungFlowService, GungModalService, ProductService, SelectedCustomerService } from 'gung-standard';
import { first, forkJoin, from, Observable, of, switchMap } from 'rxjs';
import { TyloExportQuotationModalComponent } from '../components/tylo-export-quotation-modal/tylo-export-quotation-modal.component';

interface ModalResult {
  email?: string;
  additionalInfo?: string;
}
@Injectable({
  providedIn: 'root'
})
export class TyloCartExportService extends CartExportService {
  constructor(
    protected http: HttpClient,
    protected productService: ProductService,
    protected authService: AuthService,
    protected selectedCustomerService: SelectedCustomerService,
    protected gungFlowService: GungFlowService,
    protected gungModalService: GungModalService,
    protected translateService: TranslateService,
    protected ngbModal: NgbModal
  ) {
    super(http, productService, authService, selectedCustomerService, gungFlowService, gungModalService, translateService)
  }

  getCustomerCurrency(customer: Customer): string {
    return customer.extra?.kus?.valkod;
  }

  protected buildExportRequestFromModal(
    exportSelectionDataType: ExportCartSelectionDataType,
    cart: Cart,
    template?: string,
    additionalVariables?: {},
    additionalParams?: {}
  ): Observable<{ isValid: boolean; body: any }> {
    // build request body
    return this.getExportRequestBodyByType(
      exportSelectionDataType,
      cart,
      template,
      additionalVariables,
      additionalParams
    ).pipe(
      first(),
      switchMap((data: any) => {
        let modal$: Observable<ModalResult>
        if(data.template === 'QUOTE_PDF_EXPORT'){
          modal$ = from(this.exportQuotation(data.recipient)).pipe(first());
        }else{
          modal$ = from(this.gungModalService.openConfirmExportModal(data.recipient)).pipe(first())
        }
        
        console.log('data', data);

        return forkJoin({
          data: of(data),
          modalOutput: modal$
        });
      }),
      switchMap(({ data, modalOutput }) => {
        
        let isValid = false;

        if (modalOutput && modalOutput.email) {
          isValid = true;
          data.recipient = modalOutput.email;
          if(modalOutput.additionalInfo){
            data.params.extra.additionalInfo = modalOutput.additionalInfo;
          }
        }


        return of({ isValid, body: data });
      })
    );
  }


  exportQuotation(email: string, template?: string): Promise<any> {
    const id = TyloExportQuotationModalComponent.name;

    const ref = this.ngbModal.open(TyloExportQuotationModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: true
    });
    ref.componentInstance.delegate = this;
    ref.componentInstance.email = email;

    return ref.result;
  }

}
